import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-dialog',
  standalone: false,
  templateUrl: './delete-dialog.html',
  styleUrl: './delete-dialog.less'
})
export class DeleteDialog {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private matDialogRef:MatDialogRef<DeleteDialog>,
  ){

  }

  ngOnInit(): void {
    
  }

  response(value:any){
    this.matDialogRef.close(value);
  }
}
